import {NgModule} from "@angular/core";
import {SharedModule} from "../../shared.module";
import {AssignmentsEditableComponent} from "./assignments-editable/assignments-editable.component";
import {FormSelectComponent} from "./form/select/select.component";
import {AssignmentSelectComponent} from "./form/select/assignment-select-component/assignment-select.component";
import {FormComponent} from "./form/form-component/form.component";
import {ReloadComponent} from "./form/reload/reload.component";
import {SelectModule} from "ng2-select-compat";
import {MultiselectModule} from "../multiselect/multiselect.module";
import {SelectMultipleComponent} from "./form/selectmultiple/select-multiple.component";
import {InputComponent} from "./form/input/input.component";
import {TextareaComponent} from "./form/textarea/textarea.component";
import {DataTablesModule} from "angular-datatables";


@NgModule({
	declarations: [
		AssignmentsEditableComponent,
		FormSelectComponent,
		FormComponent,
		AssignmentSelectComponent,
		ReloadComponent,
		SelectMultipleComponent,
		InputComponent,
		TextareaComponent
	],
	imports: [
		DataTablesModule,
		SharedModule,
		SelectModule,
		MultiselectModule
	],
	exports: [
		AssignmentsEditableComponent
	]
})
export class AssignmentsModule
{
} // end class AssignmentsModule